<template>
  <div class="d-inline-block">
    <div style="height: 20px;">
      <vc-share-a href="https://translate.google.com/">
        <img
          v-if="displayingTranslationText"
          class="buttonImage"
          src="./assets/translated_by_google_grayscale.png"
          style="height: 20px;"
          alt=""
        />
      </vc-share-a>
    </div>
    <img
      class="buttonImage"
      src="./assets/google_logo.png"
      style="vertical-align: middle; width: 15px; height: 15px;"
      alt=""
    />
    <a
      style="vertical-align: middle;"
      v-on="{
        click: displayingTranslationText
          ? displayOriginalText
          : displayTranslatedText
      }"
    >
      {{
        displayingTranslationText
          ? this.lang.show_original_text
          : this.lang.show_translation_text
      }}
    </a>
  </div>
</template>

<script>
export default {
  name: "vc-share-contents-translation-button",
  props: {
    code: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          show_original_text: "原文で見る",
          show_translation_text: "Googleで翻訳"
        };
      }
    },
    getContentsOriginalText: {
      type: Function,
      default: () => {}
    },
    getContentsTranslatedText: {
      type: Function,
      default: () => {}
    },
    displayingTranslationText: {
      type: Boolean,
      default: true
    },
    updateDisplayingTranslationText: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    displayOriginalText: function(event) {
      event.preventDefault();

      this.getContentsOriginalText(this.code).then(value => {
        if (value.status === 0) {
          const textElements = document.querySelectorAll(
            "[data-contents-description]"
          );
          if (textElements) {
            textElements.forEach(textElement => {
              textElement.innerText = value.data.description;
            });
          }
          this.updateDisplayingTranslationText(false);
        }
      });
    },
    displayTranslatedText: function(event) {
      event.preventDefault();

      this.getContentsTranslatedText(this.code).then(value => {
        if (value.status === 0) {
          const textElements = document.querySelectorAll(
            "[data-contents-description]"
          );
          if (textElements) {
            textElements.forEach(textElement => {
              textElement.innerText = value.data.description;
            });
          }
          this.updateDisplayingTranslationText(true);
        }
      });
    }
  }
};
</script>
